import { render, staticRenderFns } from "./MastheadLogo.vue?vue&type=template&id=64046823&"
import script from "./MastheadLogo.vue?vue&type=script&lang=js&"
export * from "./MastheadLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports